import { status } from 'skin/event/status';

const check = (obj, form, story, data, d, action) => {
	return status.ignore;
};

export default check;
